import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Orange_White_Border_Btn.css";

const Orange_White_Border_Btn = (props) => {
  return (
    <button
      className={`premium-orange-btn ${props.className || ""}`}
      onClick={props?.onClick}
      type={props?.type || "button"}
      disabled={props?.disabled}
    >
      {props?.icon && (
        <div className="btn-icon-wrapper">
          <FontAwesomeIcon icon={props.icon} className="btn-icon" />
        </div>
      )}
      <span className="btn-text">{props?.btn_name}</span>
    </button>
  );
};

export default Orange_White_Border_Btn;